import React from "react";
import Table from "react-bootstrap/Table";

import Loading from "./Table/Loading";
import Empty from "./Table/Empty";
import Th from "./Table/Th";
import Td from "./Table/Td";

const Template = ({ children, ...props }) => (
  <Table responsive {...props}>
    {children}
  </Table>
);

export default Object.assign(Template, { Td, Th, Empty, Loading });
